import { render, staticRenderFns } from "./submitResume.vue?vue&type=template&id=3bb745ee&scoped=true"
import script from "./submitResume.vue?vue&type=script&lang=js"
export * from "./submitResume.vue?vue&type=script&lang=js"
import style0 from "./submitResume.vue?vue&type=style&index=0&id=3bb745ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb745ee",
  null
  
)

export default component.exports